<template>
  <v-container fluid>
    <v-row>
      <Banner />
      <v-col class="form-half" cols="12" md="6">
        <v-row class="fill-height pa-0 ma-0" align="center">
          <v-col cols="12" md="9">
            <v-container>
              <img src="@/assets/Global/images/svg/dark-logo.svg" class="auth-layout-logo" alt="" />
              <br /><br />
               <h2>Reset Password</h2>
              <br />
              <div>
                <v-form autocomplete="off" ref="form">
                  <label>Enter OTP</label>
                  <dtunes-otpinput v-model="otp" autofocus :CODE_LENGTH="CODE_LENGTH" />
                  <br>
                  <label>Enter new Paswword</label>
                  <v-text-field
                    placeholder="8+ characters"
                    class="form-input"
                    single-line
                    autocomplete="new-password"
                    color="#F36F2E"
                    v-model="password"
                    :rules="passwordRules"
                    :type="show1 ? 'text' : 'password'"
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    outlined
                    @click:append="show1 = !show1"
                  ></v-text-field>
                  <label>Confirm new Password</label>
                  <v-text-field
                    placeholder="8+ characters"
                    class="form-input"
                    single-line
                    color="#F36F2E"
                    v-model="cpassword"
                    :rules="cpasswordRules"
                    :type="show2 ? 'text' : 'password'"
                    :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                    outlined
                    @click:append="show2 = !show2"
                  ></v-text-field>
                  <Button @click="validateForm" :loading="loading" :disabled="!isComplete">Reset Password</Button>
                </v-form>
                <br>
              </div>
            </v-container>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Button from "@/components/Buttons/default-button.vue";
import Banner from "../components/banner.vue";
import DtunesOtpinput from '../../../components/dtunes-otp-input.vue';
import { mapActions } from "vuex";

export default {
  data: () => ({
    loading: false,
    show1: false,
    show2:false,
    password: "",
    cpassword:"",
    otp:"",
    CODE_LENGTH:4,
    passwordRules: [(v) => !!v || "Password is required"],
    cpasswordRules: [(v) => !!v || "Password is required"],
  }),
  components: {
    Button,
    Banner,
    DtunesOtpinput,
  },
  computed: {
    isComplete() {
      return this.password && this.cpassword;
    },
  },
  methods: {
    ...mapActions("auth", ["reset"]),
    validateForm() {
      if(localStorage.getItem('email')){
        if (this.$refs.form.validate()) {
          this.submitForm();
        }
      }
      else{
        alert("null")
        this.$router.push({
          path:'/forgot-password'
        })
      }
      
    },
    async submitForm() {
      this.loading = true;
      let form = {
        email: localStorage.getItem('email'),
        otp:this.otp,
        password: this.password,
        cpassword:this.cpassword
      };
      try {
        await this.reset(form);
      } catch (err) {
        this.loading = false;
        for (const errors in err) {
          let errorName = this[errors];
          this[errors + "Rules"].push(
            (v) => (v && v !== errorName) || err[errors]
          );
          this.$refs.form.validate();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../components/style.scss';
</style>